import { render } from "./ExpandablePanelSection.vue?vue&type=template&id=2b9d6fd2"
import script from "./ExpandablePanelSection.vue?vue&type=script&lang=js"
export * from "./ExpandablePanelSection.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__